"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const getStyles = ({ theme }) => ({
    root: {
        display: "flex",
        flexDirection: "row",
        p: 2,
    },
    header: {
        display: "flex",
        flexDirection: "row",
        rowGap: theme.spacing(2),
    },
    actions: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        columnGap: theme.spacing(2),
    },
});
/**
 * This is the component used to render the header inside of a Section component. The title props can be overridden by
 * passing in a TypographyProps.
 *
 * @example Rendering a simple header with no actions and overriding the header role to syntactically display an h1 tag
 * ```typescript
 *
 *    <SectionHeader title="Header Title" TypographyProps={{variantMapping: {h5: "h1"}}}/>
 *
 * ```
 *
 * @example Rendering simple header with multiple buttons
 * ```typescript
 *      const actions = [<button>Action 1</button>, <button>Action 2</button>]
 *    <SectionHeader title="Header Title" Actions={actions}/>
 * ```
 * @category component
 */
const SectionHeader = (props) => {
    const { actions, title, TypographyProps = {}, sx, ...restProps } = props;
    const theme = (0, material_1.useTheme)();
    const styles = getStyles({ theme });
    return (react_1.default.createElement(Box_1.default, { sx: [styles.root, ...(Array.isArray(sx) ? sx : [sx])], ...restProps },
        react_1.default.createElement(Box_1.default, { sx: styles.header },
            react_1.default.createElement(Typography_1.default, { variant: "h5", variantMapping: { h5: "h2" }, ...TypographyProps }, title)),
        actions && (react_1.default.createElement(Box_1.default, { sx: styles.actions }, actions.map((action, index) => (react_1.default.createElement("div", { key: index },
            " ",
            action,
            " ")))))));
};
exports.default = SectionHeader;
